import { ReactElement } from 'react';

interface ConditionalWrapperProps {
    condition: boolean;
    wrapper: (children: ReactElement) => ReactElement;
    children: ReactElement;
}

export const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapperProps) => (condition ? wrapper(children) : children);
